import{extendTailwindMerge as e}from"tailwind-merge";var d=e({extend:{classGroups:{heading:["heading-1","heading-2","heading-3","heading-4","heading-5","heading-6"]}}});export{d as a};
